{
  "supplemental": {
    "version": {
      "_unicodeVersion": "16.0.0",
      "_cldrVersion": "48"
    },
    "metaZones": {
      "metazoneInfo": {
        "timezone": {
          "Africa": {
            "Abidjan": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "Accra": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "Addis_Ababa": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Eastern"
                }
              }
            ],
            "Algiers": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Western",
                  "_to": "1977-10-20 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central",
                  "_from": "1977-10-20 23:00",
                  "_to": "1979-10-25 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Western",
                  "_from": "1979-10-25 23:00",
                  "_to": "1981-05-01 00:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central",
                  "_from": "1981-05-01 00:00"
                }
              }
            ],
            "Asmera": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Eastern"
                }
              }
            ],
            "Bamako": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "Bangui": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western"
                }
              }
            ],
            "Banjul": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "Bissau": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_FarWestern",
                  "_to": "1975-01-01 01:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "GMT",
                  "_from": "1975-01-01 01:00"
                }
              }
            ],
            "Blantyre": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central"
                }
              }
            ],
            "Brazzaville": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western"
                }
              }
            ],
            "Bujumbura": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central"
                }
              }
            ],
            "Cairo": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern"
                }
              }
            ],
            "Casablanca": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Western",
                  "_to": "1984-03-16 00:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central",
                  "_from": "1984-03-16 00:00",
                  "_to": "1985-12-31 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Western",
                  "_from": "1985-12-31 23:00",
                  "_to": "2018-10-28 02:00"
                }
              }
            ],
            "Ceuta": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Western",
                  "_to": "1984-03-16 00:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central",
                  "_from": "1984-03-16 00:00"
                }
              }
            ],
            "Conakry": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "Dakar": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "Dar_es_Salaam": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Eastern"
                }
              }
            ],
            "Djibouti": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Eastern"
                }
              }
            ],
            "Douala": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western"
                }
              }
            ],
            "El_Aaiun": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_FarWestern",
                  "_to": "1976-04-14 01:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Western",
                  "_from": "1976-04-14 01:00",
                  "_to": "2018-10-28 02:00"
                }
              }
            ],
            "Freetown": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "Gaborone": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central"
                }
              }
            ],
            "Harare": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central"
                }
              }
            ],
            "Johannesburg": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Southern"
                }
              }
            ],
            "Juba": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central",
                  "_to": "2000-01-15 10:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Africa_Eastern",
                  "_from": "2000-01-15 10:00",
                  "_to": "2021-01-31 21:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central",
                  "_from": "2021-01-31 21:00"
                }
              }
            ],
            "Kampala": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Eastern"
                }
              }
            ],
            "Khartoum": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central",
                  "_to": "2000-01-15 10:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Africa_Eastern",
                  "_from": "2000-01-15 10:00",
                  "_to": "2017-10-31 21:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central",
                  "_from": "2017-10-31 21:00"
                }
              }
            ],
            "Kigali": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central"
                }
              }
            ],
            "Kinshasa": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western"
                }
              }
            ],
            "Lagos": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western"
                }
              }
            ],
            "Libreville": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western"
                }
              }
            ],
            "Lome": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "Luanda": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western"
                }
              }
            ],
            "Lubumbashi": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central"
                }
              }
            ],
            "Lusaka": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central"
                }
              }
            ],
            "Malabo": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western"
                }
              }
            ],
            "Maputo": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central"
                }
              }
            ],
            "Maseru": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Southern"
                }
              }
            ],
            "Mbabane": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Southern"
                }
              }
            ],
            "Mogadishu": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Eastern"
                }
              }
            ],
            "Monrovia": [
              {
                "usesMetazone": {
                  "_mzone": "Liberia",
                  "_to": "1972-01-07 00:45"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "GMT",
                  "_from": "1972-01-07 00:45"
                }
              }
            ],
            "Nairobi": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Eastern"
                }
              }
            ],
            "Ndjamena": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western"
                }
              }
            ],
            "Niamey": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western"
                }
              }
            ],
            "Nouakchott": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "Ouagadougou": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "Porto-Novo": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western"
                }
              }
            ],
            "Sao_Tome": [
              {
                "usesMetazone": {
                  "_mzone": "GMT",
                  "_to": "2018-01-01 01:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western",
                  "_from": "2018-01-01 01:00",
                  "_to": "2019-01-01 01:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "GMT",
                  "_from": "2019-01-01 01:00"
                }
              }
            ],
            "Tripoli": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_to": "1981-12-31 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central",
                  "_from": "1981-12-31 22:00",
                  "_to": "1990-05-03 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1990-05-03 23:00",
                  "_to": "1996-09-29 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central",
                  "_from": "1996-09-29 22:00",
                  "_to": "1997-10-03 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1997-10-03 22:00",
                  "_to": "2012-11-10 00:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central",
                  "_from": "2012-11-10 00:00",
                  "_to": "2013-10-25 00:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "2013-10-25 00:00"
                }
              }
            ],
            "Tunis": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Windhoek": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Southern",
                  "_to": "1990-03-20 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central",
                  "_from": "1990-03-20 22:00",
                  "_to": "1994-03-20 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Africa_Western",
                  "_stdOffset": "+01",
                  "_dstOffset": "+02",
                  "_from": "1994-03-20 22:00",
                  "_to": "2017-10-23 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Africa_Central",
                  "_from": "2017-10-23 22:00"
                }
              }
            ]
          },
          "America": {
            "Adak": [
              {
                "usesMetazone": {
                  "_mzone": "Bering",
                  "_to": "1983-10-30 12:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Hawaii_Aleutian",
                  "_from": "1983-11-30 10:00"
                }
              }
            ],
            "Anchorage": [
              {
                "usesMetazone": {
                  "_mzone": "Alaska_Hawaii",
                  "_to": "1983-10-30 11:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Alaska",
                  "_from": "1983-11-30 09:00"
                }
              }
            ],
            "Anguilla": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Antigua": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Araguaina": [
              {
                "usesMetazone": {
                  "_mzone": "Brasilia"
                }
              }
            ],
            "Argentina": {
              "La_Rioja": [
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_to": "1991-03-01 02:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina_Western",
                    "_from": "1991-03-01 02:00",
                    "_to": "1991-05-07 04:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "1991-05-07 04:00",
                    "_to": "2004-06-01 03:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina_Western",
                    "_from": "2004-06-01 03:00",
                    "_to": "2004-06-20 04:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "2004-06-20 04:00"
                  }
                }
              ],
              "Rio_Gallegos": [
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_to": "2004-06-01 03:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina_Western",
                    "_from": "2004-06-01 03:00",
                    "_to": "2004-06-20 04:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "2004-06-20 04:00"
                  }
                }
              ],
              "Salta": [
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_to": "1991-03-03 02:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "1991-10-20 04:00"
                  }
                }
              ],
              "San_Juan": [
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_to": "1991-03-01 02:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina_Western",
                    "_from": "1991-03-01 02:00",
                    "_to": "1991-05-07 04:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "1991-05-07 04:00",
                    "_to": "2004-05-31 03:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina_Western",
                    "_from": "2004-05-31 03:00",
                    "_to": "2004-07-25 04:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "2004-07-25 04:00"
                  }
                }
              ],
              "San_Luis": [
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_to": "1990-03-14 02:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina_Western",
                    "_from": "1990-03-14 02:00",
                    "_to": "1991-06-01 04:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "1991-06-01 04:00",
                    "_to": "1999-10-03 03:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina_Western",
                    "_from": "1999-10-03 03:00",
                    "_to": "2000-03-03 03:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "2000-03-03 03:00",
                    "_to": "2004-05-31 03:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina_Western",
                    "_from": "2004-05-31 03:00",
                    "_to": "2004-07-25 04:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "2004-07-25 04:00",
                    "_to": "2008-01-21 02:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina_Western",
                    "_from": "2008-01-21 02:00",
                    "_to": "2009-10-11 04:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "2009-10-11 04:00"
                  }
                }
              ],
              "Tucuman": [
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_to": "1991-03-03 02:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "1991-10-20 04:00",
                    "_to": "2004-06-01 03:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina_Western",
                    "_from": "2004-06-01 03:00",
                    "_to": "2004-06-13 04:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "2004-06-13 04:00"
                  }
                }
              ],
              "Ushuaia": [
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_to": "2004-05-30 03:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "Argentina",
                    "_from": "2004-06-20 04:00"
                  }
                }
              ]
            },
            "Aruba": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Asuncion": [
              {
                "usesMetazone": {
                  "_mzone": "Paraguay"
                }
              }
            ],
            "Bahia": [
              {
                "usesMetazone": {
                  "_mzone": "Brasilia"
                }
              }
            ],
            "Bahia_Banderas": [
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain",
                  "_to": "2010-04-04 09:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2010-04-04 09:00"
                }
              }
            ],
            "Barbados": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Belem": [
              {
                "usesMetazone": {
                  "_mzone": "Brasilia"
                }
              }
            ],
            "Belize": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central"
                }
              }
            ],
            "Blanc-Sablon": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Boa_Vista": [
              {
                "usesMetazone": {
                  "_mzone": "Amazon"
                }
              }
            ],
            "Bogota": [
              {
                "usesMetazone": {
                  "_mzone": "Colombia"
                }
              }
            ],
            "Boise": [
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain"
                }
              }
            ],
            "Buenos_Aires": [
              {
                "usesMetazone": {
                  "_mzone": "Argentina"
                }
              }
            ],
            "Cambridge_Bay": [
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain",
                  "_to": "1999-10-31 08:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1999-10-31 08:00",
                  "_to": "2000-10-29 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "2000-10-29 07:00",
                  "_to": "2000-11-05 05:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2000-11-05 05:00",
                  "_to": "2001-04-01 09:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain",
                  "_from": "2001-04-01 09:00"
                }
              }
            ],
            "Campo_Grande": [
              {
                "usesMetazone": {
                  "_mzone": "Amazon"
                }
              }
            ],
            "Cancun": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_to": "1981-12-26 08:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "1981-12-26 08:00",
                  "_to": "1983-01-04 05:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1983-01-04 05:00",
                  "_to": "1997-10-26 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "1997-10-26 07:00",
                  "_to": "1998-08-02 06:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1998-08-02 06:00",
                  "_to": "2015-02-01 08:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "2015-02-01 08:00"
                }
              }
            ],
            "Caracas": [
              {
                "usesMetazone": {
                  "_mzone": "Venezuela"
                }
              }
            ],
            "Catamarca": [
              {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_to": "1991-03-03 02:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "1991-10-20 04:00",
                  "_to": "2004-06-01 03:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Argentina_Western",
                  "_from": "2004-06-01 03:00",
                  "_to": "2004-06-20 04:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "2004-06-20 04:00"
                }
              }
            ],
            "Cayenne": [
              {
                "usesMetazone": {
                  "_mzone": "French_Guiana"
                }
              }
            ],
            "Cayman": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern"
                }
              }
            ],
            "Chicago": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central"
                }
              }
            ],
            "Chihuahua": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_to": "1998-04-05 09:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Mexico_Pacific",
                  "_from": "1998-04-05 09:00",
                  "_to": "2022-10-30 08:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2022-10-30 08:00"
                }
              }
            ],
            "Ciudad_Juarez": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_to": "1998-04-05 09:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Mexico_Pacific",
                  "_from": "1998-04-05 09:00",
                  "_to": "2022-10-30 08:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2022-10-30 08:00",
                  "_to": "2022-11-30 06:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain",
                  "_from": "2022-11-30 06:00"
                }
              }
            ],
            "Coral_Harbour": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern"
                }
              }
            ],
            "Cordoba": [
              {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_to": "1991-03-03 02:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "1991-10-20 04:00"
                }
              }
            ],
            "Costa_Rica": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central"
                }
              }
            ],
            "Coyhaique": [
              {
                "usesMetazone": {
                  "_mzone": "Chile",
                  "_to": "2025-03-20 03:00"
                }
              }
            ],
            "Creston": [
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain"
                }
              }
            ],
            "Cuiaba": [
              {
                "usesMetazone": {
                  "_mzone": "Amazon"
                }
              }
            ],
            "Curacao": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Danmarkshavn": [
              {
                "usesMetazone": {
                  "_mzone": "Greenland_Western",
                  "_to": "1996-01-01 03:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "GMT",
                  "_from": "1996-01-01 03:00"
                }
              }
            ],
            "Dawson": [
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific",
                  "_from": "1973-10-28 09:00",
                  "_to": "2020-11-01 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Yukon",
                  "_from": "2020-11-01 07:00"
                }
              }
            ],
            "Dawson_Creek": [
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific",
                  "_to": "1972-08-30 09:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain",
                  "_from": "1972-08-30 09:00"
                }
              }
            ],
            "Denver": [
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain"
                }
              }
            ],
            "Detroit": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern"
                }
              }
            ],
            "Dominica": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Edmonton": [
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain"
                }
              }
            ],
            "Eirunepe": [
              {
                "usesMetazone": {
                  "_mzone": "Acre",
                  "_to": "2008-06-24 05:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Amazon",
                  "_from": "2008-06-24 05:00",
                  "_to": "2013-11-10 04:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Acre",
                  "_from": "2013-11-10 04:00"
                }
              }
            ],
            "El_Salvador": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central"
                }
              }
            ],
            "Fort_Nelson": [
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific",
                  "_to": "2015-03-08 10:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain",
                  "_from": "2015-03-08 10:00"
                }
              }
            ],
            "Fortaleza": [
              {
                "usesMetazone": {
                  "_mzone": "Brasilia"
                }
              }
            ],
            "Glace_Bay": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Godthab": [
              {
                "usesMetazone": {
                  "_mzone": "Greenland_Western",
                  "_to": "2024-03-26 01:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Greenland",
                  "_from": "2024-03-26 01:00"
                }
              }
            ],
            "Goose_Bay": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic",
                  "_to": "1988-04-03 04:01"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Goose_Bay",
                  "_from": "1988-04-03 04:01",
                  "_to": "1988-10-30 02:01"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Atlantic",
                  "_from": "1988-10-30 02:01"
                }
              }
            ],
            "Grand_Turk": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_to": "2015-03-08 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Atlantic",
                  "_from": "2015-03-08 07:00",
                  "_to": "2018-03-11 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "2018-03-11 07:00"
                }
              }
            ],
            "Grenada": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Guadeloupe": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Guatemala": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central"
                }
              }
            ],
            "Guayaquil": [
              {
                "usesMetazone": {
                  "_mzone": "Ecuador"
                }
              }
            ],
            "Guyana": [
              {
                "usesMetazone": {
                  "_mzone": "Guyana"
                }
              }
            ],
            "Halifax": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Havana": [
              {
                "usesMetazone": {
                  "_mzone": "Cuba"
                }
              }
            ],
            "Hermosillo": [
              {
                "usesMetazone": {
                  "_mzone": "Mexico_Pacific"
                }
              }
            ],
            "Indiana": {
              "Knox": [
                {
                  "usesMetazone": {
                    "_mzone": "America_Central",
                    "_to": "1991-10-27 07:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Eastern",
                    "_from": "1991-10-27 07:00",
                    "_to": "2006-04-02 07:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Central",
                    "_from": "2006-04-02 07:00"
                  }
                }
              ],
              "Marengo": [
                {
                  "usesMetazone": {
                    "_mzone": "America_Eastern",
                    "_to": "1974-01-06 07:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Central",
                    "_from": "1974-01-06 07:00",
                    "_to": "1974-10-27 07:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Eastern",
                    "_from": "1974-10-27 07:00"
                  }
                }
              ],
              "Petersburg": [
                {
                  "usesMetazone": {
                    "_mzone": "America_Central",
                    "_to": "1977-10-30 07:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Eastern",
                    "_from": "1977-10-30 07:00",
                    "_to": "2006-04-02 07:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Central",
                    "_from": "2006-04-02 07:00",
                    "_to": "2007-11-04 07:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Eastern",
                    "_from": "2007-11-04 07:00"
                  }
                }
              ],
              "Tell_City": [
                {
                  "usesMetazone": {
                    "_mzone": "America_Eastern",
                    "_to": "2006-04-02 07:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Central",
                    "_from": "2006-04-02 07:00"
                  }
                }
              ],
              "Vevay": [
                {
                  "usesMetazone": {
                    "_mzone": "America_Eastern"
                  }
                }
              ],
              "Vincennes": [
                {
                  "usesMetazone": {
                    "_mzone": "America_Eastern",
                    "_to": "2006-04-02 07:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Central",
                    "_from": "2006-04-02 07:00",
                    "_to": "2007-11-04 07:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Eastern",
                    "_from": "2007-11-04 07:00"
                  }
                }
              ],
              "Winamac": [
                {
                  "usesMetazone": {
                    "_mzone": "America_Eastern",
                    "_to": "2006-04-02 07:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Central",
                    "_from": "2006-04-02 07:00",
                    "_to": "2007-03-11 08:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Eastern",
                    "_from": "2007-03-11 08:00"
                  }
                }
              ]
            },
            "Indianapolis": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern"
                }
              }
            ],
            "Inuvik": [
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific",
                  "_to": "1979-04-29 10:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain",
                  "_from": "1979-04-29 10:00"
                }
              }
            ],
            "Iqaluit": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_to": "1999-10-31 06:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1999-10-31 06:00",
                  "_to": "2000-10-29 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "2000-10-29 07:00"
                }
              }
            ],
            "Jamaica": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern"
                }
              }
            ],
            "Jujuy": [
              {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_to": "1990-03-04 02:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "1991-10-06 04:00"
                }
              }
            ],
            "Juneau": [
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific",
                  "_to": "1980-04-27 10:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific",
                  "_from": "1980-10-26 10:00",
                  "_to": "1983-10-30 09:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Alaska",
                  "_from": "1983-11-30 09:00"
                }
              }
            ],
            "Kentucky": {
              "Monticello": [
                {
                  "usesMetazone": {
                    "_mzone": "America_Central",
                    "_to": "2000-10-29 07:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Eastern",
                    "_from": "2000-10-29 07:00"
                  }
                }
              ]
            },
            "Kralendijk": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "La_Paz": [
              {
                "usesMetazone": {
                  "_mzone": "Bolivia"
                }
              }
            ],
            "Lima": [
              {
                "usesMetazone": {
                  "_mzone": "Peru"
                }
              }
            ],
            "Los_Angeles": [
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific"
                }
              }
            ],
            "Louisville": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_to": "1974-01-06 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1974-01-06 07:00",
                  "_to": "1974-10-27 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "1974-10-27 07:00"
                }
              }
            ],
            "Lower_Princes": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Maceio": [
              {
                "usesMetazone": {
                  "_mzone": "Brasilia"
                }
              }
            ],
            "Managua": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_to": "1973-05-01 06:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "1973-05-01 06:00",
                  "_to": "1975-02-16 05:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1975-02-16 05:00",
                  "_to": "1992-01-01 10:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "1992-01-01 10:00",
                  "_to": "1992-09-24 05:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1992-09-24 05:00",
                  "_to": "1993-01-01 06:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "1993-01-01 06:00",
                  "_to": "1997-01-01 05:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1997-01-01 05:00"
                }
              }
            ],
            "Manaus": [
              {
                "usesMetazone": {
                  "_mzone": "Amazon"
                }
              }
            ],
            "Marigot": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Martinique": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Matamoros": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central"
                }
              }
            ],
            "Mazatlan": [
              {
                "usesMetazone": {
                  "_mzone": "Mexico_Pacific"
                }
              }
            ],
            "Mendoza": [
              {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_to": "1990-03-04 02:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "1992-10-18 04:00",
                  "_to": "2004-05-23 03:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_from": "2004-09-26 04:00"
                }
              }
            ],
            "Menominee": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_to": "1973-04-29 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1973-04-29 07:00"
                }
              }
            ],
            "Merida": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_to": "1981-12-26 08:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "1981-12-26 08:00",
                  "_to": "1982-11-02 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1982-11-02 07:00"
                }
              }
            ],
            "Metlakatla": [
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific",
                  "_to": "2015-11-01 10:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Alaska",
                  "_from": "2015-11-01 10:00",
                  "_to": "2018-11-04 10:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific",
                  "_from": "2018-11-04 10:00",
                  "_to": "2019-01-20 10:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Alaska",
                  "_from": "2019-01-20 10:00"
                }
              }
            ],
            "Mexico_City": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central"
                }
              }
            ],
            "Miquelon": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic",
                  "_to": "1980-05-01 04:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Pierre_Miquelon",
                  "_from": "1980-05-01 04:00"
                }
              }
            ],
            "Moncton": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Monterrey": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central"
                }
              }
            ],
            "Montevideo": [
              {
                "usesMetazone": {
                  "_mzone": "Uruguay"
                }
              }
            ],
            "Montserrat": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Nassau": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern"
                }
              }
            ],
            "New_York": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern"
                }
              }
            ],
            "Nome": [
              {
                "usesMetazone": {
                  "_mzone": "Bering",
                  "_to": "1983-10-30 12:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Alaska",
                  "_from": "1983-11-30 09:00"
                }
              }
            ],
            "Noronha": [
              {
                "usesMetazone": {
                  "_mzone": "Noronha"
                }
              }
            ],
            "North_Dakota": {
              "Beulah": [
                {
                  "usesMetazone": {
                    "_mzone": "America_Mountain",
                    "_to": "2010-11-07 08:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Central",
                    "_from": "2010-11-07 08:00"
                  }
                }
              ],
              "Center": [
                {
                  "usesMetazone": {
                    "_mzone": "America_Mountain",
                    "_to": "1992-10-25 08:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Central",
                    "_from": "1992-10-25 08:00"
                  }
                }
              ],
              "New_Salem": [
                {
                  "usesMetazone": {
                    "_mzone": "America_Mountain",
                    "_to": "2003-10-26 08:00"
                  }
                },
                {
                  "usesMetazone": {
                    "_mzone": "America_Central",
                    "_from": "2003-10-26 08:00"
                  }
                }
              ]
            },
            "Ojinaga": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_to": "1998-04-05 09:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain",
                  "_from": "1998-04-05 09:00",
                  "_to": "2022-10-30 08:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2022-10-30 08:00"
                }
              }
            ],
            "Panama": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern"
                }
              }
            ],
            "Paramaribo": [
              {
                "usesMetazone": {
                  "_mzone": "Dutch_Guiana",
                  "_to": "1975-11-20 03:30"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Suriname",
                  "_from": "1975-11-20 03:30"
                }
              }
            ],
            "Phoenix": [
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain"
                }
              }
            ],
            "Port_of_Spain": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Port-au-Prince": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern"
                }
              }
            ],
            "Porto_Velho": [
              {
                "usesMetazone": {
                  "_mzone": "Amazon"
                }
              }
            ],
            "Puerto_Rico": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Punta_Arenas": [
              {
                "usesMetazone": {
                  "_mzone": "Chile",
                  "_to": "2016-12-03 23:00"
                }
              }
            ],
            "Rankin_Inlet": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_to": "2000-10-29 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "2000-10-29 07:00",
                  "_to": "2001-04-01 08:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2001-04-01 08:00"
                }
              }
            ],
            "Recife": [
              {
                "usesMetazone": {
                  "_mzone": "Brasilia"
                }
              }
            ],
            "Regina": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central"
                }
              }
            ],
            "Resolute": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_to": "2000-10-29 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "2000-10-29 07:00",
                  "_to": "2001-04-01 08:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2001-04-01 08:00",
                  "_to": "2006-10-29 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "2006-10-29 07:00",
                  "_to": "2007-03-11 08:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "2007-03-11 08:00"
                }
              }
            ],
            "Rio_Branco": [
              {
                "usesMetazone": {
                  "_mzone": "Acre",
                  "_to": "2008-06-24 05:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Amazon",
                  "_from": "2008-06-24 05:00",
                  "_to": "2013-11-10 04:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Acre",
                  "_from": "2013-11-10 04:00"
                }
              }
            ],
            "Santarem": [
              {
                "usesMetazone": {
                  "_mzone": "Amazon",
                  "_to": "2008-06-24 04:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Brasilia",
                  "_from": "2008-06-24 04:00"
                }
              }
            ],
            "Santiago": [
              {
                "usesMetazone": {
                  "_mzone": "Chile"
                }
              }
            ],
            "Santo_Domingo": [
              {
                "usesMetazone": {
                  "_mzone": "Dominican",
                  "_to": "1974-10-27 05:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Atlantic",
                  "_from": "1974-10-27 05:00",
                  "_to": "2000-10-29 06:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern",
                  "_from": "2000-10-29 06:00",
                  "_to": "2000-12-03 06:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Atlantic",
                  "_from": "2000-12-03 06:00"
                }
              }
            ],
            "Sao_Paulo": [
              {
                "usesMetazone": {
                  "_mzone": "Brasilia"
                }
              }
            ],
            "Scoresbysund": [
              {
                "usesMetazone": {
                  "_mzone": "Greenland_Central",
                  "_to": "1981-03-29 02:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Greenland_Eastern",
                  "_from": "1981-03-29 02:00",
                  "_to": "2024-03-31 01:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Greenland",
                  "_from": "2024-03-31 01:00"
                }
              }
            ],
            "Sitka": [
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific",
                  "_to": "1983-10-30 09:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Alaska",
                  "_from": "1983-11-30 09:00"
                }
              }
            ],
            "St_Barthelemy": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "St_Johns": [
              {
                "usesMetazone": {
                  "_mzone": "Newfoundland"
                }
              }
            ],
            "St_Kitts": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "St_Lucia": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "St_Thomas": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "St_Vincent": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Swift_Current": [
              {
                "usesMetazone": {
                  "_mzone": "America_Mountain",
                  "_to": "1972-04-30 09:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "America_Central",
                  "_from": "1972-04-30 09:00"
                }
              }
            ],
            "Tegucigalpa": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central"
                }
              }
            ],
            "Thule": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Tijuana": [
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific"
                }
              }
            ],
            "Toronto": [
              {
                "usesMetazone": {
                  "_mzone": "America_Eastern"
                }
              }
            ],
            "Tortola": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Vancouver": [
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific"
                }
              }
            ],
            "Whitehorse": [
              {
                "usesMetazone": {
                  "_mzone": "America_Pacific",
                  "_to": "2020-11-01 07:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Yukon",
                  "_from": "2020-11-01 07:00"
                }
              }
            ],
            "Winnipeg": [
              {
                "usesMetazone": {
                  "_mzone": "America_Central"
                }
              }
            ],
            "Yakutat": [
              {
                "usesMetazone": {
                  "_mzone": "Alaska",
                  "_from": "1983-11-30 09:00"
                }
              }
            ]
          },
          "Antarctica": {
            "Casey": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_Western",
                  "_to": "2009-10-17 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Casey",
                  "_from": "2009-10-17 18:00",
                  "_to": "2010-03-04 15:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Australia_Western",
                  "_from": "2010-03-04 15:00",
                  "_to": "2011-10-27 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Casey",
                  "_from": "2011-10-27 18:00",
                  "_to": "2012-02-21 17:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Australia_Western",
                  "_from": "2012-02-21 17:00",
                  "_to": "2016-10-21 16:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Casey",
                  "_from": "2016-10-21 16:00",
                  "_to": "2018-03-10 17:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Australia_Western",
                  "_from": "2018-03-10 17:00",
                  "_to": "2018-10-06 20:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Casey",
                  "_from": "2018-10-06 20:00",
                  "_to": "2019-03-16 16:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Australia_Western",
                  "_from": "2019-03-16 16:00",
                  "_to": "2019-10-03 19:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Casey",
                  "_from": "2019-10-03 19:00",
                  "_to": "2020-03-07 16:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Australia_Western",
                  "_from": "2020-03-07 16:00",
                  "_to": "2020-10-03 16:01"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Casey",
                  "_from": "2020-10-03 16:01",
                  "_to": "2021-03-13 13:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Australia_Western",
                  "_from": "2021-03-13 13:00",
                  "_to": "2021-10-02 16:01"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Casey",
                  "_from": "2021-10-02 16:01",
                  "_to": "2022-03-12 13:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Australia_Western",
                  "_from": "2022-03-12 13:00",
                  "_to": "2022-10-01 16:01"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Casey",
                  "_from": "2022-10-01 16:01",
                  "_to": "2023-03-08 16:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Australia_Western",
                  "_from": "2023-03-08 16:00"
                }
              }
            ],
            "Davis": [
              {
                "usesMetazone": {
                  "_mzone": "Davis"
                }
              }
            ],
            "DumontDUrville": [
              {
                "usesMetazone": {
                  "_mzone": "DumontDUrville"
                }
              }
            ],
            "Macquarie": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_Eastern"
                }
              }
            ],
            "Mawson": [
              {
                "usesMetazone": {
                  "_mzone": "Mawson"
                }
              }
            ],
            "McMurdo": [
              {
                "usesMetazone": {
                  "_mzone": "New_Zealand"
                }
              }
            ],
            "Palmer": [
              {
                "usesMetazone": {
                  "_mzone": "Argentina",
                  "_to": "1982-05-01 03:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Chile",
                  "_from": "1982-05-01 03:00",
                  "_to": "2016-12-04 03:00"
                }
              }
            ],
            "Rothera": [
              {
                "usesMetazone": {
                  "_mzone": "Rothera"
                }
              }
            ],
            "Syowa": [
              {
                "usesMetazone": {
                  "_mzone": "Syowa"
                }
              }
            ],
            "Troll": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "Vostok": [
              {
                "usesMetazone": {
                  "_mzone": "Vostok"
                }
              }
            ]
          },
          "Arctic": {
            "Longyearbyen": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ]
          },
          "Asia": {
            "Aden": [
              {
                "usesMetazone": {
                  "_mzone": "Arabian"
                }
              }
            ],
            "Almaty": [
              {
                "usesMetazone": {
                  "_mzone": "Almaty",
                  "_to": "2004-10-30 20:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan_Eastern",
                  "_from": "2004-10-30 20:00",
                  "_to": "2024-02-29 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan",
                  "_from": "2024-02-29 18:00"
                }
              }
            ],
            "Amman": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_to": "2022-10-27 22:00"
                }
              }
            ],
            "Anadyr": [
              {
                "usesMetazone": {
                  "_mzone": "Anadyr",
                  "_to": "2010-03-27 14:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Magadan",
                  "_from": "2010-03-27 14:00",
                  "_to": "2011-03-26 15:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kamchatka",
                  "_from": "2011-03-26 15:00"
                }
              }
            ],
            "Aqtau": [
              {
                "usesMetazone": {
                  "_mzone": "Shevchenko",
                  "_to": "1991-12-15 19:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Aqtau",
                  "_from": "1991-12-15 19:00",
                  "_to": "2004-10-30 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan_Western",
                  "_from": "2004-10-30 22:00",
                  "_to": "2024-02-29 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan",
                  "_from": "2024-02-29 18:00"
                }
              }
            ],
            "Aqtobe": [
              {
                "usesMetazone": {
                  "_mzone": "Aktyubinsk",
                  "_to": "1991-12-15 19:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Aqtobe",
                  "_from": "1991-12-15 19:00",
                  "_to": "2004-10-30 21:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan_Western",
                  "_from": "2004-10-30 21:00",
                  "_to": "2024-02-29 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan",
                  "_from": "2024-02-29 18:00"
                }
              }
            ],
            "Ashgabat": [
              {
                "usesMetazone": {
                  "_mzone": "Ashkhabad",
                  "_to": "1992-01-18 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Turkmenistan",
                  "_from": "1992-01-18 22:00"
                }
              }
            ],
            "Atyrau": [
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan_Western",
                  "_from": "2004-10-30 22:00",
                  "_to": "2024-02-29 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan",
                  "_from": "2024-02-29 18:00"
                }
              }
            ],
            "Baghdad": [
              {
                "usesMetazone": {
                  "_mzone": "Arabian"
                }
              }
            ],
            "Bahrain": [
              {
                "usesMetazone": {
                  "_mzone": "Gulf",
                  "_to": "1972-05-31 20:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Arabian",
                  "_from": "1972-05-31 20:00"
                }
              }
            ],
            "Baku": [
              {
                "usesMetazone": {
                  "_mzone": "Baku",
                  "_to": "1991-03-30 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Azerbaijan",
                  "_from": "1991-03-30 22:00"
                }
              }
            ],
            "Bangkok": [
              {
                "usesMetazone": {
                  "_mzone": "Indochina"
                }
              }
            ],
            "Barnaul": [
              {
                "usesMetazone": {
                  "_mzone": "Krasnoyarsk",
                  "_from": "2016-03-26 20:00"
                }
              }
            ],
            "Beirut": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern"
                }
              }
            ],
            "Bishkek": [
              {
                "usesMetazone": {
                  "_mzone": "Frunze",
                  "_to": "1991-03-30 20:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kyrgystan",
                  "_from": "1991-03-30 20:00"
                }
              }
            ],
            "Brunei": [
              {
                "usesMetazone": {
                  "_mzone": "Brunei"
                }
              }
            ],
            "Calcutta": [
              {
                "usesMetazone": {
                  "_mzone": "India"
                }
              }
            ],
            "Chita": [
              {
                "usesMetazone": {
                  "_mzone": "Yakutsk",
                  "_to": "2014-10-25 16:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Irkutsk",
                  "_from": "2014-10-25 17:00",
                  "_to": "2016-03-26 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Yakutsk",
                  "_from": "2016-03-26 18:00"
                }
              }
            ],
            "Colombo": [
              {
                "usesMetazone": {
                  "_mzone": "India",
                  "_to": "1996-05-24 18:30"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Lanka",
                  "_from": "1996-05-24 18:30",
                  "_to": "2006-04-14 18:30"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "India",
                  "_from": "2006-04-14 18:30"
                }
              }
            ],
            "Damascus": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_to": "2022-10-27 21:00"
                }
              }
            ],
            "Dhaka": [
              {
                "usesMetazone": {
                  "_mzone": "Dacca",
                  "_to": "1971-03-25 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Bangladesh",
                  "_from": "1971-03-25 18:00"
                }
              }
            ],
            "Dili": [
              {
                "usesMetazone": {
                  "_mzone": "East_Timor",
                  "_to": "1976-05-02 15:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Indonesia_Central",
                  "_from": "1976-05-02 15:00",
                  "_to": "2000-09-16 16:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "East_Timor",
                  "_from": "2000-09-16 16:00"
                }
              }
            ],
            "Dubai": [
              {
                "usesMetazone": {
                  "_mzone": "Gulf"
                }
              }
            ],
            "Dushanbe": [
              {
                "usesMetazone": {
                  "_mzone": "Dushanbe",
                  "_to": "1991-09-08 21:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Tajikistan",
                  "_from": "1991-09-08 21:00"
                }
              }
            ],
            "Famagusta": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_to": "2016-09-07 21:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "2017-10-29 01:00"
                }
              }
            ],
            "Gaza": [
              {
                "usesMetazone": {
                  "_mzone": "Israel",
                  "_to": "1995-12-31 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1995-12-31 22:00"
                }
              }
            ],
            "Hebron": [
              {
                "usesMetazone": {
                  "_mzone": "Israel",
                  "_to": "1995-12-31 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1995-12-31 22:00"
                }
              }
            ],
            "Hong_Kong": [
              {
                "usesMetazone": {
                  "_mzone": "Hong_Kong"
                }
              }
            ],
            "Hovd": [
              {
                "usesMetazone": {
                  "_mzone": "Hovd"
                }
              }
            ],
            "Irkutsk": [
              {
                "usesMetazone": {
                  "_mzone": "Irkutsk"
                }
              }
            ],
            "Jakarta": [
              {
                "usesMetazone": {
                  "_mzone": "Indonesia_Western"
                }
              }
            ],
            "Jayapura": [
              {
                "usesMetazone": {
                  "_mzone": "Indonesia_Eastern"
                }
              }
            ],
            "Jerusalem": [
              {
                "usesMetazone": {
                  "_mzone": "Israel"
                }
              }
            ],
            "Kabul": [
              {
                "usesMetazone": {
                  "_mzone": "Afghanistan"
                }
              }
            ],
            "Kamchatka": [
              {
                "usesMetazone": {
                  "_mzone": "Kamchatka"
                }
              }
            ],
            "Karachi": [
              {
                "usesMetazone": {
                  "_mzone": "Karachi",
                  "_to": "1971-03-25 19:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Pakistan",
                  "_from": "1971-03-25 19:00"
                }
              }
            ],
            "Katmandu": [
              {
                "usesMetazone": {
                  "_mzone": "Nepal"
                }
              }
            ],
            "Khandyga": [
              {
                "usesMetazone": {
                  "_mzone": "Yakutsk",
                  "_to": "2003-12-31 15:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Vladivostok",
                  "_from": "2003-12-31 15:00",
                  "_to": "2011-09-12 13:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Yakutsk",
                  "_from": "2011-09-12 13:00"
                }
              }
            ],
            "Krasnoyarsk": [
              {
                "usesMetazone": {
                  "_mzone": "Krasnoyarsk"
                }
              }
            ],
            "Kuala_Lumpur": [
              {
                "usesMetazone": {
                  "_mzone": "Malaya",
                  "_to": "1981-12-31 16:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Malaysia",
                  "_from": "1981-12-31 16:00"
                }
              }
            ],
            "Kuching": [
              {
                "usesMetazone": {
                  "_mzone": "Borneo",
                  "_to": "1981-12-31 16:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Malaysia",
                  "_from": "1981-12-31 16:00"
                }
              }
            ],
            "Kuwait": [
              {
                "usesMetazone": {
                  "_mzone": "Arabian"
                }
              }
            ],
            "Macau": [
              {
                "usesMetazone": {
                  "_mzone": "Macau",
                  "_to": "1999-12-19 16:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "China",
                  "_from": "1999-12-19 16:00"
                }
              }
            ],
            "Magadan": [
              {
                "usesMetazone": {
                  "_mzone": "Magadan"
                }
              }
            ],
            "Makassar": [
              {
                "usesMetazone": {
                  "_mzone": "Indonesia_Central"
                }
              }
            ],
            "Manila": [
              {
                "usesMetazone": {
                  "_mzone": "Philippines"
                }
              }
            ],
            "Muscat": [
              {
                "usesMetazone": {
                  "_mzone": "Gulf"
                }
              }
            ],
            "Nicosia": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern"
                }
              }
            ],
            "Novokuznetsk": [
              {
                "usesMetazone": {
                  "_mzone": "Krasnoyarsk",
                  "_to": "2010-03-27 19:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Novosibirsk",
                  "_from": "2010-03-27 19:00",
                  "_to": "2014-10-25 19:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Krasnoyarsk",
                  "_from": "2014-10-25 19:00"
                }
              }
            ],
            "Novosibirsk": [
              {
                "usesMetazone": {
                  "_mzone": "Novosibirsk",
                  "_to": "2016-07-23 20:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Krasnoyarsk",
                  "_from": "2016-07-23 20:00"
                }
              }
            ],
            "Omsk": [
              {
                "usesMetazone": {
                  "_mzone": "Omsk"
                }
              }
            ],
            "Oral": [
              {
                "usesMetazone": {
                  "_mzone": "Uralsk",
                  "_to": "1991-12-15 20:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Oral",
                  "_from": "1991-12-15 20:00",
                  "_to": "2004-10-30 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan_Western",
                  "_from": "2004-10-30 22:00",
                  "_to": "2024-02-29 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan",
                  "_from": "2024-02-29 18:00"
                }
              }
            ],
            "Phnom_Penh": [
              {
                "usesMetazone": {
                  "_mzone": "Indochina"
                }
              }
            ],
            "Pontianak": [
              {
                "usesMetazone": {
                  "_mzone": "Indonesia_Central",
                  "_to": "1987-12-31 16:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Indonesia_Western",
                  "_from": "1987-12-31 16:00"
                }
              }
            ],
            "Pyongyang": [
              {
                "usesMetazone": {
                  "_mzone": "Korea",
                  "_to": "2015-08-14 15:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Pyongyang",
                  "_from": "2015-08-14 15:00",
                  "_to": "2018-05-04 15:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Korea",
                  "_from": "2018-05-04 15:00"
                }
              }
            ],
            "Qatar": [
              {
                "usesMetazone": {
                  "_mzone": "Gulf",
                  "_to": "1972-05-31 20:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Arabian",
                  "_from": "1972-05-31 20:00"
                }
              }
            ],
            "Qostanay": [
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan_Eastern",
                  "_from": "2004-10-30 21:00",
                  "_to": "2024-02-29 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan",
                  "_from": "2024-02-29 18:00"
                }
              }
            ],
            "Qyzylorda": [
              {
                "usesMetazone": {
                  "_mzone": "Kizilorda",
                  "_to": "1991-12-15 19:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Qyzylorda",
                  "_from": "1991-12-15 19:00",
                  "_to": "2004-10-30 21:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan_Eastern",
                  "_from": "2004-10-30 21:00",
                  "_to": "2018-12-20 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan_Western",
                  "_from": "2018-12-20 18:00",
                  "_to": "2024-02-29 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Kazakhstan",
                  "_from": "2024-02-29 18:00"
                }
              }
            ],
            "Rangoon": [
              {
                "usesMetazone": {
                  "_mzone": "Myanmar"
                }
              }
            ],
            "Riyadh": [
              {
                "usesMetazone": {
                  "_mzone": "Arabian"
                }
              }
            ],
            "Saigon": [
              {
                "usesMetazone": {
                  "_mzone": "Indochina",
                  "_from": "1975-06-12 16:00"
                }
              }
            ],
            "Sakhalin": [
              {
                "usesMetazone": {
                  "_mzone": "Sakhalin",
                  "_to": "2014-10-25 15:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Magadan",
                  "_from": "2014-10-25 15:00",
                  "_to": "2016-03-26 16:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Magadan",
                  "_from": "2016-04-26 16:00"
                }
              }
            ],
            "Samarkand": [
              {
                "usesMetazone": {
                  "_mzone": "Samarkand",
                  "_to": "1981-09-30 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Tashkent",
                  "_from": "1981-09-30 18:00",
                  "_to": "1982-03-31 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Samarkand",
                  "_from": "1982-03-31 18:00",
                  "_to": "1991-08-31 18:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Uzbekistan",
                  "_from": "1991-08-31 18:00"
                }
              }
            ],
            "Seoul": [
              {
                "usesMetazone": {
                  "_mzone": "Korea"
                }
              }
            ],
            "Shanghai": [
              {
                "usesMetazone": {
                  "_mzone": "China"
                }
              }
            ],
            "Singapore": [
              {
                "usesMetazone": {
                  "_mzone": "Singapore"
                }
              }
            ],
            "Srednekolymsk": [
              {
                "usesMetazone": {
                  "_mzone": "Magadan",
                  "_to": "2014-10-25 14:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Magadan",
                  "_from": "2016-04-23 16:00"
                }
              }
            ],
            "Taipei": [
              {
                "usesMetazone": {
                  "_mzone": "Taipei"
                }
              }
            ],
            "Tashkent": [
              {
                "usesMetazone": {
                  "_mzone": "Tashkent",
                  "_to": "1991-03-30 20:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Uzbekistan",
                  "_from": "1991-03-30 20:00"
                }
              }
            ],
            "Tbilisi": [
              {
                "usesMetazone": {
                  "_mzone": "Tbilisi",
                  "_to": "1991-03-30 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Georgia",
                  "_from": "1991-03-30 22:00"
                }
              }
            ],
            "Tehran": [
              {
                "usesMetazone": {
                  "_mzone": "Iran"
                }
              }
            ],
            "Thimphu": [
              {
                "usesMetazone": {
                  "_mzone": "India",
                  "_to": "1987-09-30 18:30"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Bhutan",
                  "_from": "1987-09-30 18:30"
                }
              }
            ],
            "Tokyo": [
              {
                "usesMetazone": {
                  "_mzone": "Japan"
                }
              }
            ],
            "Tomsk": [
              {
                "usesMetazone": {
                  "_mzone": "Krasnoyarsk",
                  "_from": "2016-05-28 20:00"
                }
              }
            ],
            "Ulaanbaatar": [
              {
                "usesMetazone": {
                  "_mzone": "Mongolia"
                }
              }
            ],
            "Urumqi": [
              {
                "usesMetazone": {
                  "_mzone": "Urumqi"
                }
              }
            ],
            "Ust-Nera": [
              {
                "usesMetazone": {
                  "_mzone": "Yakutsk",
                  "_to": "1981-03-31 15:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Magadan",
                  "_from": "1981-03-31 15:00",
                  "_to": "2011-09-12 12:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Vladivostok",
                  "_from": "2011-09-12 12:00"
                }
              }
            ],
            "Vientiane": [
              {
                "usesMetazone": {
                  "_mzone": "Indochina"
                }
              }
            ],
            "Vladivostok": [
              {
                "usesMetazone": {
                  "_mzone": "Vladivostok"
                }
              }
            ],
            "Yakutsk": [
              {
                "usesMetazone": {
                  "_mzone": "Yakutsk"
                }
              }
            ],
            "Yekaterinburg": [
              {
                "usesMetazone": {
                  "_mzone": "Sverdlovsk",
                  "_to": "1992-01-18 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Yekaterinburg",
                  "_from": "1992-01-18 22:00"
                }
              }
            ],
            "Yerevan": [
              {
                "usesMetazone": {
                  "_mzone": "Yerevan",
                  "_to": "1991-03-30 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Armenia",
                  "_from": "1991-03-30 22:00"
                }
              }
            ]
          },
          "Atlantic": {
            "Azores": [
              {
                "usesMetazone": {
                  "_mzone": "Azores",
                  "_to": "1992-12-27 02:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Western",
                  "_from": "1992-12-27 02:00",
                  "_to": "1993-06-17 01:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Azores",
                  "_from": "1993-06-17 01:00"
                }
              }
            ],
            "Bermuda": [
              {
                "usesMetazone": {
                  "_mzone": "Atlantic"
                }
              }
            ],
            "Canary": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Western"
                }
              }
            ],
            "Cape_Verde": [
              {
                "usesMetazone": {
                  "_mzone": "Cape_Verde"
                }
              }
            ],
            "Faeroe": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Western"
                }
              }
            ],
            "Madeira": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Western"
                }
              }
            ],
            "Reykjavik": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "South_Georgia": [
              {
                "usesMetazone": {
                  "_mzone": "South_Georgia"
                }
              }
            ],
            "St_Helena": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ],
            "Stanley": [
              {
                "usesMetazone": {
                  "_mzone": "Falkland"
                }
              }
            ]
          },
          "Australia": {
            "Adelaide": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_Central"
                }
              }
            ],
            "Brisbane": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_Eastern"
                }
              }
            ],
            "Broken_Hill": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_Central"
                }
              }
            ],
            "Darwin": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_Central"
                }
              }
            ],
            "Eucla": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_CentralWestern"
                }
              }
            ],
            "Hobart": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_Eastern"
                }
              }
            ],
            "Lindeman": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_Eastern"
                }
              }
            ],
            "Lord_Howe": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_Eastern",
                  "_to": "1981-02-28 14:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Lord_Howe",
                  "_from": "1981-02-28 14:00"
                }
              }
            ],
            "Melbourne": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_Eastern"
                }
              }
            ],
            "Perth": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_Western"
                }
              }
            ],
            "Sydney": [
              {
                "usesMetazone": {
                  "_mzone": "Australia_Eastern"
                }
              }
            ]
          },
          "Etc": {
            "GMT": [
              {
                "usesMetazone": {
                  "_mzone": "GMT"
                }
              }
            ]
          },
          "Europe": {
            "Amsterdam": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Andorra": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Astrakhan": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_from": "1992-03-28 22:00",
                  "_to": "2016-03-26 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Samara",
                  "_from": "2016-03-26 23:00"
                }
              }
            ],
            "Athens": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern"
                }
              }
            ],
            "Belgrade": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Berlin": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Bratislava": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Brussels": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Bucharest": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern"
                }
              }
            ],
            "Budapest": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Busingen": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Chisinau": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_to": "1990-05-05 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1990-05-05 22:00"
                }
              }
            ],
            "Copenhagen": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Dublin": [
              {
                "usesMetazone": {
                  "_mzone": "Irish",
                  "_stdOffset": "+00",
                  "_dstOffset": "+01",
                  "_to": "1971-10-31 02:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "GMT",
                  "_stdOffset": "+00",
                  "_dstOffset": "+01",
                  "_from": "1971-10-31 02:00"
                }
              }
            ],
            "Gibraltar": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Guernsey": [
              {
                "usesMetazone": {
                  "_mzone": "British",
                  "_to": "1971-10-31 02:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "GMT",
                  "_from": "1971-10-31 02:00"
                }
              }
            ],
            "Helsinki": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern"
                }
              }
            ],
            "Isle_of_Man": [
              {
                "usesMetazone": {
                  "_mzone": "British",
                  "_to": "1971-10-31 02:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "GMT",
                  "_from": "1971-10-31 02:00"
                }
              }
            ],
            "Istanbul": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_to": "1978-06-28 21:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Turkey",
                  "_from": "1978-06-28 21:00",
                  "_to": "1984-10-31 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1984-10-31 23:00",
                  "_to": "2016-09-06 21:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Turkey",
                  "_from": "2016-09-06 21:00"
                }
              }
            ],
            "Jersey": [
              {
                "usesMetazone": {
                  "_mzone": "British",
                  "_to": "1971-10-31 02:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "GMT",
                  "_from": "1971-10-31 02:00"
                }
              }
            ],
            "Kaliningrad": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_to": "1989-03-25 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1989-03-25 23:00",
                  "_to": "2011-03-27 00:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Further_Eastern",
                  "_from": "2011-03-27 00:00",
                  "_to": "2014-10-25 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "2014-10-25 23:00"
                }
              }
            ],
            "Kiev": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_to": "1990-06-30 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1990-06-30 22:00"
                }
              }
            ],
            "Kirov": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_from": "2014-10-25 22:00"
                }
              }
            ],
            "Lisbon": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central",
                  "_to": "1976-09-26 00:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Western",
                  "_from": "1976-09-26 00:00",
                  "_to": "1992-09-27 01:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central",
                  "_from": "1992-09-27 01:00",
                  "_to": "1996-03-31 01:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Western",
                  "_from": "1996-03-31 01:00"
                }
              }
            ],
            "Ljubljana": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "London": [
              {
                "usesMetazone": {
                  "_mzone": "British",
                  "_to": "1971-10-31 02:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "GMT",
                  "_from": "1971-10-31 02:00"
                }
              }
            ],
            "Luxembourg": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Madrid": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Malta": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Mariehamn": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern"
                }
              }
            ],
            "Minsk": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_to": "1991-03-30 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1991-03-30 23:00",
                  "_to": "2011-03-27 00:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Further_Eastern",
                  "_from": "2011-03-27 00:00",
                  "_to": "2014-10-26 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_from": "2014-10-26 22:00"
                }
              }
            ],
            "Monaco": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Moscow": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_to": "1991-03-30 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1991-03-30 23:00",
                  "_to": "1992-01-19 00:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_from": "1992-01-19 00:00"
                }
              }
            ],
            "Oslo": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Paris": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Podgorica": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Prague": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Riga": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_to": "1989-03-25 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1989-03-25 23:00"
                }
              }
            ],
            "Rome": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Samara": [
              {
                "usesMetazone": {
                  "_mzone": "Kuybyshev",
                  "_to": "1989-03-25 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_from": "1989-03-25 22:00",
                  "_to": "1991-03-30 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1991-03-30 23:00",
                  "_to": "1991-09-29 00:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Samara",
                  "_from": "1991-09-29 00:00"
                }
              }
            ],
            "San_Marino": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Sarajevo": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Saratov": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_from": "1992-03-28 22:00",
                  "_to": "2016-12-03 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Samara",
                  "_from": "2016-12-03 23:00"
                }
              }
            ],
            "Simferopol": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_to": "1990-06-30 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1990-06-30 23:00",
                  "_to": "1994-04-30 21:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_from": "1994-04-30 21:00",
                  "_to": "1997-03-30 01:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1997-03-30 01:00",
                  "_to": "2014-03-30 00:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_from": "2014-03-30 00:00"
                }
              }
            ],
            "Skopje": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Sofia": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern"
                }
              }
            ],
            "Stockholm": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Tallinn": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_to": "1989-03-25 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1989-03-25 23:00"
                }
              }
            ],
            "Tirane": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Ulyanovsk": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_from": "1992-01-19 00:00",
                  "_to": "2016-03-26 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Samara",
                  "_from": "2016-03-26 23:00"
                }
              }
            ],
            "Vaduz": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Vatican": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Vienna": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Vilnius": [
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_to": "1989-03-25 23:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1989-03-25 23:00",
                  "_to": "1998-03-29 01:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central",
                  "_from": "1998-03-29 01:00",
                  "_to": "1999-10-31 01:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Europe_Eastern",
                  "_from": "1999-10-31 01:00"
                }
              }
            ],
            "Volgograd": [
              {
                "usesMetazone": {
                  "_mzone": "Volgograd",
                  "_to": "2020-12-26 22:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Moscow",
                  "_from": "2020-12-26 22:00"
                }
              }
            ],
            "Warsaw": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Zagreb": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ],
            "Zurich": [
              {
                "usesMetazone": {
                  "_mzone": "Europe_Central"
                }
              }
            ]
          },
          "Indian": {
            "Antananarivo": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Eastern"
                }
              }
            ],
            "Chagos": [
              {
                "usesMetazone": {
                  "_mzone": "Indian_Ocean"
                }
              }
            ],
            "Christmas": [
              {
                "usesMetazone": {
                  "_mzone": "Christmas"
                }
              }
            ],
            "Cocos": [
              {
                "usesMetazone": {
                  "_mzone": "Cocos"
                }
              }
            ],
            "Comoro": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Eastern"
                }
              }
            ],
            "Kerguelen": [
              {
                "usesMetazone": {
                  "_mzone": "French_Southern"
                }
              }
            ],
            "Mahe": [
              {
                "usesMetazone": {
                  "_mzone": "Seychelles"
                }
              }
            ],
            "Maldives": [
              {
                "usesMetazone": {
                  "_mzone": "Maldives"
                }
              }
            ],
            "Mauritius": [
              {
                "usesMetazone": {
                  "_mzone": "Mauritius"
                }
              }
            ],
            "Mayotte": [
              {
                "usesMetazone": {
                  "_mzone": "Africa_Eastern"
                }
              }
            ],
            "Reunion": [
              {
                "usesMetazone": {
                  "_mzone": "Reunion"
                }
              }
            ]
          },
          "Pacific": {
            "Apia": [
              {
                "usesMetazone": {
                  "_mzone": "Apia"
                }
              }
            ],
            "Auckland": [
              {
                "usesMetazone": {
                  "_mzone": "New_Zealand"
                }
              }
            ],
            "Bougainville": [
              {
                "usesMetazone": {
                  "_mzone": "Papua_New_Guinea",
                  "_to": "2014-12-27 16:00"
                }
              }
            ],
            "Chatham": [
              {
                "usesMetazone": {
                  "_mzone": "Chatham"
                }
              }
            ],
            "Easter": [
              {
                "usesMetazone": {
                  "_mzone": "Easter"
                }
              }
            ],
            "Efate": [
              {
                "usesMetazone": {
                  "_mzone": "Vanuatu"
                }
              }
            ],
            "Enderbury": [
              {
                "usesMetazone": {
                  "_mzone": "Phoenix_Islands"
                }
              }
            ],
            "Fakaofo": [
              {
                "usesMetazone": {
                  "_mzone": "Tokelau"
                }
              }
            ],
            "Fiji": [
              {
                "usesMetazone": {
                  "_mzone": "Fiji"
                }
              }
            ],
            "Funafuti": [
              {
                "usesMetazone": {
                  "_mzone": "Tuvalu"
                }
              }
            ],
            "Galapagos": [
              {
                "usesMetazone": {
                  "_mzone": "Ecuador",
                  "_to": "1986-01-01 05:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Galapagos",
                  "_from": "1986-01-01 05:00"
                }
              }
            ],
            "Gambier": [
              {
                "usesMetazone": {
                  "_mzone": "Gambier"
                }
              }
            ],
            "Guadalcanal": [
              {
                "usesMetazone": {
                  "_mzone": "Solomon"
                }
              }
            ],
            "Guam": [
              {
                "usesMetazone": {
                  "_mzone": "Guam",
                  "_to": "2000-12-22 14:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Chamorro",
                  "_from": "2000-12-22 14:00"
                }
              }
            ],
            "Honolulu": [
              {
                "usesMetazone": {
                  "_mzone": "Hawaii"
                }
              }
            ],
            "Kiritimati": [
              {
                "usesMetazone": {
                  "_mzone": "Line_Islands"
                }
              }
            ],
            "Kosrae": [
              {
                "usesMetazone": {
                  "_mzone": "Kosrae"
                }
              }
            ],
            "Kwajalein": [
              {
                "usesMetazone": {
                  "_mzone": "Kwajalein",
                  "_to": "1993-08-21 12:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Marshall_Islands",
                  "_from": "1993-08-21 12:00"
                }
              }
            ],
            "Majuro": [
              {
                "usesMetazone": {
                  "_mzone": "Marshall_Islands"
                }
              }
            ],
            "Marquesas": [
              {
                "usesMetazone": {
                  "_mzone": "Marquesas"
                }
              }
            ],
            "Midway": [
              {
                "usesMetazone": {
                  "_mzone": "Bering",
                  "_to": "1983-10-30 12:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Samoa",
                  "_from": "1983-10-30 12:00"
                }
              }
            ],
            "Nauru": [
              {
                "usesMetazone": {
                  "_mzone": "Nauru"
                }
              }
            ],
            "Niue": [
              {
                "usesMetazone": {
                  "_mzone": "Niue"
                }
              }
            ],
            "Norfolk": [
              {
                "usesMetazone": {
                  "_mzone": "Norfolk"
                }
              }
            ],
            "Noumea": [
              {
                "usesMetazone": {
                  "_mzone": "New_Caledonia"
                }
              }
            ],
            "Pago_Pago": [
              {
                "usesMetazone": {
                  "_mzone": "Bering",
                  "_to": "1983-10-30 12:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Samoa",
                  "_from": "1983-10-30 12:00"
                }
              }
            ],
            "Palau": [
              {
                "usesMetazone": {
                  "_mzone": "Palau"
                }
              }
            ],
            "Pitcairn": [
              {
                "usesMetazone": {
                  "_mzone": "Pitcairn"
                }
              }
            ],
            "Ponape": [
              {
                "usesMetazone": {
                  "_mzone": "Ponape"
                }
              }
            ],
            "Port_Moresby": [
              {
                "usesMetazone": {
                  "_mzone": "Papua_New_Guinea"
                }
              }
            ],
            "Rarotonga": [
              {
                "usesMetazone": {
                  "_mzone": "Cook"
                }
              }
            ],
            "Saipan": [
              {
                "usesMetazone": {
                  "_mzone": "North_Mariana",
                  "_to": "2000-12-22 14:00"
                }
              },
              {
                "usesMetazone": {
                  "_mzone": "Chamorro",
                  "_from": "2000-12-22 14:00"
                }
              }
            ],
            "Tahiti": [
              {
                "usesMetazone": {
                  "_mzone": "Tahiti"
                }
              }
            ],
            "Tarawa": [
              {
                "usesMetazone": {
                  "_mzone": "Gilbert_Islands"
                }
              }
            ],
            "Tongatapu": [
              {
                "usesMetazone": {
                  "_mzone": "Tonga"
                }
              }
            ],
            "Truk": [
              {
                "usesMetazone": {
                  "_mzone": "Truk"
                }
              }
            ],
            "Wake": [
              {
                "usesMetazone": {
                  "_mzone": "Wake"
                }
              }
            ],
            "Wallis": [
              {
                "usesMetazone": {
                  "_mzone": "Wallis"
                }
              }
            ]
          }
        }
      },
      "metazones": [
        {
          "mapZone": {
            "_other": "Acre",
            "_type": "America/Rio_Branco",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Afghanistan",
            "_type": "Asia/Kabul",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Central",
            "_type": "Africa/Maputo",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Central",
            "_type": "Africa/Bujumbura",
            "_territory": "BI"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Central",
            "_type": "Africa/Gaborone",
            "_territory": "BW"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Central",
            "_type": "Africa/Lubumbashi",
            "_territory": "CD"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Central",
            "_type": "Africa/Blantyre",
            "_territory": "MW"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Central",
            "_type": "Africa/Kigali",
            "_territory": "RW"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Central",
            "_type": "Africa/Lusaka",
            "_territory": "ZM"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Central",
            "_type": "Africa/Harare",
            "_territory": "ZW"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Eastern",
            "_type": "Africa/Nairobi",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Eastern",
            "_type": "Africa/Djibouti",
            "_territory": "DJ"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Eastern",
            "_type": "Africa/Asmera",
            "_territory": "ER"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Eastern",
            "_type": "Africa/Addis_Ababa",
            "_territory": "ET"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Eastern",
            "_type": "Indian/Comoro",
            "_territory": "KM"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Eastern",
            "_type": "Indian/Antananarivo",
            "_territory": "MG"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Eastern",
            "_type": "Africa/Mogadishu",
            "_territory": "SO"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Eastern",
            "_type": "Africa/Dar_es_Salaam",
            "_territory": "TZ"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Eastern",
            "_type": "Africa/Kampala",
            "_territory": "UG"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Eastern",
            "_type": "Indian/Mayotte",
            "_territory": "YT"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_FarWestern",
            "_type": "Africa/El_Aaiun",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Southern",
            "_type": "Africa/Johannesburg",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Southern",
            "_type": "Africa/Maseru",
            "_territory": "LS"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Southern",
            "_type": "Africa/Mbabane",
            "_territory": "SZ"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Western",
            "_type": "Africa/Lagos",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Western",
            "_type": "Africa/Luanda",
            "_territory": "AO"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Western",
            "_type": "Africa/Porto-Novo",
            "_territory": "BJ"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Western",
            "_type": "Africa/Kinshasa",
            "_territory": "CD"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Western",
            "_type": "Africa/Bangui",
            "_territory": "CF"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Western",
            "_type": "Africa/Brazzaville",
            "_territory": "CG"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Western",
            "_type": "Africa/Douala",
            "_territory": "CM"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Western",
            "_type": "Africa/Libreville",
            "_territory": "GA"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Western",
            "_type": "Africa/Malabo",
            "_territory": "GQ"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Western",
            "_type": "Africa/Niamey",
            "_territory": "NE"
          }
        },
        {
          "mapZone": {
            "_other": "Africa_Western",
            "_type": "Africa/Ndjamena",
            "_territory": "TD"
          }
        },
        {
          "mapZone": {
            "_other": "Aktyubinsk",
            "_type": "Asia/Aqtobe",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Alaska",
            "_type": "America/Juneau",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Alaska_Hawaii",
            "_type": "America/Anchorage",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Almaty",
            "_type": "Asia/Almaty",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Amazon",
            "_type": "America/Manaus",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "America_Central",
            "_type": "America/Chicago",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "America_Central",
            "_type": "America/Belize",
            "_territory": "BZ"
          }
        },
        {
          "mapZone": {
            "_other": "America_Central",
            "_type": "America/Winnipeg",
            "_territory": "CA"
          }
        },
        {
          "mapZone": {
            "_other": "America_Central",
            "_type": "America/Costa_Rica",
            "_territory": "CR"
          }
        },
        {
          "mapZone": {
            "_other": "America_Central",
            "_type": "America/Guatemala",
            "_territory": "GT"
          }
        },
        {
          "mapZone": {
            "_other": "America_Central",
            "_type": "America/Tegucigalpa",
            "_territory": "HN"
          }
        },
        {
          "mapZone": {
            "_other": "America_Central",
            "_type": "America/Mexico_City",
            "_territory": "MX"
          }
        },
        {
          "mapZone": {
            "_other": "America_Central",
            "_type": "America/El_Salvador",
            "_territory": "SV"
          }
        },
        {
          "mapZone": {
            "_other": "America_Eastern",
            "_type": "America/New_York",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "America_Eastern",
            "_type": "America/Nassau",
            "_territory": "BS"
          }
        },
        {
          "mapZone": {
            "_other": "America_Eastern",
            "_type": "America/Toronto",
            "_territory": "CA"
          }
        },
        {
          "mapZone": {
            "_other": "America_Eastern",
            "_type": "America/Port-au-Prince",
            "_territory": "HT"
          }
        },
        {
          "mapZone": {
            "_other": "America_Eastern",
            "_type": "America/Jamaica",
            "_territory": "JM"
          }
        },
        {
          "mapZone": {
            "_other": "America_Eastern",
            "_type": "America/Cayman",
            "_territory": "KY"
          }
        },
        {
          "mapZone": {
            "_other": "America_Eastern",
            "_type": "America/Panama",
            "_territory": "PA"
          }
        },
        {
          "mapZone": {
            "_other": "America_Mountain",
            "_type": "America/Denver",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "America_Mountain",
            "_type": "America/Edmonton",
            "_territory": "CA"
          }
        },
        {
          "mapZone": {
            "_other": "America_Pacific",
            "_type": "America/Los_Angeles",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "America_Pacific",
            "_type": "America/Vancouver",
            "_territory": "CA"
          }
        },
        {
          "mapZone": {
            "_other": "America_Pacific",
            "_type": "America/Tijuana",
            "_territory": "MX"
          }
        },
        {
          "mapZone": {
            "_other": "Anadyr",
            "_type": "Asia/Anadyr",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Apia",
            "_type": "Pacific/Apia",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Aqtau",
            "_type": "Asia/Aqtau",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Aqtobe",
            "_type": "Asia/Aqtobe",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Arabian",
            "_type": "Asia/Riyadh",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Arabian",
            "_type": "Asia/Bahrain",
            "_territory": "BH"
          }
        },
        {
          "mapZone": {
            "_other": "Arabian",
            "_type": "Asia/Baghdad",
            "_territory": "IQ"
          }
        },
        {
          "mapZone": {
            "_other": "Arabian",
            "_type": "Asia/Kuwait",
            "_territory": "KW"
          }
        },
        {
          "mapZone": {
            "_other": "Arabian",
            "_type": "Asia/Qatar",
            "_territory": "QA"
          }
        },
        {
          "mapZone": {
            "_other": "Arabian",
            "_type": "Asia/Aden",
            "_territory": "YE"
          }
        },
        {
          "mapZone": {
            "_other": "Argentina",
            "_type": "America/Buenos_Aires",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Argentina_Western",
            "_type": "America/Argentina/San_Luis",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Armenia",
            "_type": "Asia/Yerevan",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Ashkhabad",
            "_type": "Asia/Ashgabat",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Halifax",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Antigua",
            "_territory": "AG"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Anguilla",
            "_territory": "AI"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Aruba",
            "_territory": "AW"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Barbados",
            "_territory": "BB"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "Atlantic/Bermuda",
            "_territory": "BM"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Kralendijk",
            "_territory": "BQ"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Curacao",
            "_territory": "CW"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Dominica",
            "_territory": "DM"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Grenada",
            "_territory": "GD"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Thule",
            "_territory": "GL"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Guadeloupe",
            "_territory": "GP"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/St_Kitts",
            "_territory": "KN"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/St_Lucia",
            "_territory": "LC"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Marigot",
            "_territory": "MF"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Martinique",
            "_territory": "MQ"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Montserrat",
            "_territory": "MS"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Puerto_Rico",
            "_territory": "PR"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Lower_Princes",
            "_territory": "SX"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Port_of_Spain",
            "_territory": "TT"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/St_Vincent",
            "_territory": "VC"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/Tortola",
            "_territory": "VG"
          }
        },
        {
          "mapZone": {
            "_other": "Atlantic",
            "_type": "America/St_Thomas",
            "_territory": "VI"
          }
        },
        {
          "mapZone": {
            "_other": "Australia_Central",
            "_type": "Australia/Adelaide",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Australia_CentralWestern",
            "_type": "Australia/Eucla",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Australia_Eastern",
            "_type": "Australia/Sydney",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Australia_Western",
            "_type": "Australia/Perth",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Azerbaijan",
            "_type": "Asia/Baku",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Azores",
            "_type": "Atlantic/Azores",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Baku",
            "_type": "Asia/Baku",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Bangladesh",
            "_type": "Asia/Dhaka",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Bering",
            "_type": "America/Adak",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Bhutan",
            "_type": "Asia/Thimphu",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Bolivia",
            "_type": "America/La_Paz",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Borneo",
            "_type": "Asia/Kuching",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Brasilia",
            "_type": "America/Sao_Paulo",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "British",
            "_type": "Europe/London",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Brunei",
            "_type": "Asia/Brunei",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Cape_Verde",
            "_type": "Atlantic/Cape_Verde",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Casey",
            "_type": "Antarctica/Casey",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Chamorro",
            "_type": "Pacific/Saipan",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Chamorro",
            "_type": "Pacific/Guam",
            "_territory": "GU"
          }
        },
        {
          "mapZone": {
            "_other": "Chatham",
            "_type": "Pacific/Chatham",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Chile",
            "_type": "America/Santiago",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "China",
            "_type": "Asia/Shanghai",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Christmas",
            "_type": "Indian/Christmas",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Cocos",
            "_type": "Indian/Cocos",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Colombia",
            "_type": "America/Bogota",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Cook",
            "_type": "Pacific/Rarotonga",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Cuba",
            "_type": "America/Havana",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Dacca",
            "_type": "Asia/Dhaka",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Davis",
            "_type": "Antarctica/Davis",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Dominican",
            "_type": "America/Santo_Domingo",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "DumontDUrville",
            "_type": "Antarctica/DumontDUrville",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Dushanbe",
            "_type": "Asia/Dushanbe",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Dutch_Guiana",
            "_type": "America/Paramaribo",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "East_Timor",
            "_type": "Asia/Dili",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Easter",
            "_type": "Pacific/Easter",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Ecuador",
            "_type": "America/Guayaquil",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Paris",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Andorra",
            "_territory": "AD"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Tirane",
            "_territory": "AL"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Vienna",
            "_territory": "AT"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Sarajevo",
            "_territory": "BA"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Brussels",
            "_territory": "BE"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Zurich",
            "_territory": "CH"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Prague",
            "_territory": "CZ"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Berlin",
            "_territory": "DE"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Copenhagen",
            "_territory": "DK"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Madrid",
            "_territory": "ES"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Gibraltar",
            "_territory": "GI"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Zagreb",
            "_territory": "HR"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Budapest",
            "_territory": "HU"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Rome",
            "_territory": "IT"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Vaduz",
            "_territory": "LI"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Luxembourg",
            "_territory": "LU"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Monaco",
            "_territory": "MC"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Podgorica",
            "_territory": "ME"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Skopje",
            "_territory": "MK"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Malta",
            "_territory": "MT"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Amsterdam",
            "_territory": "NL"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Oslo",
            "_territory": "NO"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Warsaw",
            "_territory": "PL"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Belgrade",
            "_territory": "RS"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Stockholm",
            "_territory": "SE"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Ljubljana",
            "_territory": "SI"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Arctic/Longyearbyen",
            "_territory": "SJ"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Bratislava",
            "_territory": "SK"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/San_Marino",
            "_territory": "SM"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Africa/Tunis",
            "_territory": "TN"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Vatican",
            "_territory": "VA"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Central",
            "_type": "Europe/Belgrade",
            "_territory": "XK"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Eastern",
            "_type": "Europe/Bucharest",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Eastern",
            "_type": "Europe/Mariehamn",
            "_territory": "AX"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Eastern",
            "_type": "Europe/Sofia",
            "_territory": "BG"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Eastern",
            "_type": "Asia/Nicosia",
            "_territory": "CY"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Eastern",
            "_type": "Africa/Cairo",
            "_territory": "EG"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Eastern",
            "_type": "Europe/Helsinki",
            "_territory": "FI"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Eastern",
            "_type": "Europe/Athens",
            "_territory": "GR"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Eastern",
            "_type": "Asia/Beirut",
            "_territory": "LB"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Further_Eastern",
            "_type": "Europe/Minsk",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Further_Eastern",
            "_type": "Europe/Kaliningrad",
            "_territory": "RU"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Western",
            "_type": "Atlantic/Canary",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Europe_Western",
            "_type": "Atlantic/Faeroe",
            "_territory": "FO"
          }
        },
        {
          "mapZone": {
            "_other": "Falkland",
            "_type": "Atlantic/Stanley",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Fiji",
            "_type": "Pacific/Fiji",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "French_Guiana",
            "_type": "America/Cayenne",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "French_Southern",
            "_type": "Indian/Kerguelen",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Frunze",
            "_type": "Asia/Bishkek",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Galapagos",
            "_type": "Pacific/Galapagos",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Gambier",
            "_type": "Pacific/Gambier",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Georgia",
            "_type": "Asia/Tbilisi",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Gilbert_Islands",
            "_type": "Pacific/Tarawa",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Atlantic/Reykjavik",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Africa/Ouagadougou",
            "_territory": "BF"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Africa/Abidjan",
            "_territory": "CI"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Europe/London",
            "_territory": "GB"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Africa/Accra",
            "_territory": "GH"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Africa/Banjul",
            "_territory": "GM"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Africa/Conakry",
            "_territory": "GN"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Europe/Dublin",
            "_territory": "IE"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Africa/Bamako",
            "_territory": "ML"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Africa/Nouakchott",
            "_territory": "MR"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Atlantic/St_Helena",
            "_territory": "SH"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Africa/Freetown",
            "_territory": "SL"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Africa/Dakar",
            "_territory": "SN"
          }
        },
        {
          "mapZone": {
            "_other": "GMT",
            "_type": "Africa/Lome",
            "_territory": "TG"
          }
        },
        {
          "mapZone": {
            "_other": "Goose_Bay",
            "_type": "America/Goose_Bay",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Greenland",
            "_type": "America/Godthab",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Greenland_Central",
            "_type": "America/Scoresbysund",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Greenland_Eastern",
            "_type": "America/Scoresbysund",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Greenland_Western",
            "_type": "America/Godthab",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Guam",
            "_type": "Pacific/Guam",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Gulf",
            "_type": "Asia/Dubai",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Gulf",
            "_type": "Asia/Muscat",
            "_territory": "OM"
          }
        },
        {
          "mapZone": {
            "_other": "Guyana",
            "_type": "America/Guyana",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Hawaii",
            "_type": "Pacific/Honolulu",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Hawaii_Aleutian",
            "_type": "America/Adak",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Hong_Kong",
            "_type": "Asia/Hong_Kong",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Hovd",
            "_type": "Asia/Hovd",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "India",
            "_type": "Asia/Calcutta",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "India",
            "_type": "Asia/Colombo",
            "_territory": "LK"
          }
        },
        {
          "mapZone": {
            "_other": "Indian_Ocean",
            "_type": "Indian/Chagos",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Indochina",
            "_type": "Asia/Bangkok",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Indochina",
            "_type": "Asia/Phnom_Penh",
            "_territory": "KH"
          }
        },
        {
          "mapZone": {
            "_other": "Indochina",
            "_type": "Asia/Vientiane",
            "_territory": "LA"
          }
        },
        {
          "mapZone": {
            "_other": "Indonesia_Central",
            "_type": "Asia/Makassar",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Indonesia_Eastern",
            "_type": "Asia/Jayapura",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Indonesia_Western",
            "_type": "Asia/Jakarta",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Iran",
            "_type": "Asia/Tehran",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Irish",
            "_type": "Europe/Dublin",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Irkutsk",
            "_type": "Asia/Irkutsk",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Israel",
            "_type": "Asia/Jerusalem",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Japan",
            "_type": "Asia/Tokyo",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Kamchatka",
            "_type": "Asia/Kamchatka",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Karachi",
            "_type": "Asia/Karachi",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Kazakhstan",
            "_type": "Asia/Almaty",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Kazakhstan_Eastern",
            "_type": "Asia/Almaty",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Kazakhstan_Western",
            "_type": "Asia/Aqtobe",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Kizilorda",
            "_type": "Asia/Qyzylorda",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Korea",
            "_type": "Asia/Seoul",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Kosrae",
            "_type": "Pacific/Kosrae",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Krasnoyarsk",
            "_type": "Asia/Krasnoyarsk",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Kuybyshev",
            "_type": "Europe/Samara",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Kwajalein",
            "_type": "Pacific/Kwajalein",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Kyrgystan",
            "_type": "Asia/Bishkek",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Lanka",
            "_type": "Asia/Colombo",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Liberia",
            "_type": "Africa/Monrovia",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Line_Islands",
            "_type": "Pacific/Kiritimati",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Lord_Howe",
            "_type": "Australia/Lord_Howe",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Macau",
            "_type": "Asia/Macau",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Magadan",
            "_type": "Asia/Magadan",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Malaya",
            "_type": "Asia/Kuala_Lumpur",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Malaysia",
            "_type": "Asia/Kuching",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Maldives",
            "_type": "Indian/Maldives",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Marquesas",
            "_type": "Pacific/Marquesas",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Marshall_Islands",
            "_type": "Pacific/Majuro",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Mauritius",
            "_type": "Indian/Mauritius",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Mawson",
            "_type": "Antarctica/Mawson",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Mexico_Pacific",
            "_type": "America/Mazatlan",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Mongolia",
            "_type": "Asia/Ulaanbaatar",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Moscow",
            "_type": "Europe/Moscow",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Myanmar",
            "_type": "Asia/Rangoon",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Nauru",
            "_type": "Pacific/Nauru",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Nepal",
            "_type": "Asia/Katmandu",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "New_Caledonia",
            "_type": "Pacific/Noumea",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "New_Zealand",
            "_type": "Pacific/Auckland",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "New_Zealand",
            "_type": "Antarctica/McMurdo",
            "_territory": "AQ"
          }
        },
        {
          "mapZone": {
            "_other": "Newfoundland",
            "_type": "America/St_Johns",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Niue",
            "_type": "Pacific/Niue",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Norfolk",
            "_type": "Pacific/Norfolk",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Noronha",
            "_type": "America/Noronha",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "North_Mariana",
            "_type": "Pacific/Saipan",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Novosibirsk",
            "_type": "Asia/Novosibirsk",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Omsk",
            "_type": "Asia/Omsk",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Oral",
            "_type": "Asia/Oral",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Pakistan",
            "_type": "Asia/Karachi",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Palau",
            "_type": "Pacific/Palau",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Papua_New_Guinea",
            "_type": "Pacific/Port_Moresby",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Paraguay",
            "_type": "America/Asuncion",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Peru",
            "_type": "America/Lima",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Philippines",
            "_type": "Asia/Manila",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Phoenix_Islands",
            "_type": "Pacific/Enderbury",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Pierre_Miquelon",
            "_type": "America/Miquelon",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Pitcairn",
            "_type": "Pacific/Pitcairn",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Ponape",
            "_type": "Pacific/Ponape",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Pyongyang",
            "_type": "Asia/Pyongyang",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Qyzylorda",
            "_type": "Asia/Qyzylorda",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Reunion",
            "_type": "Indian/Reunion",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Rothera",
            "_type": "Antarctica/Rothera",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Sakhalin",
            "_type": "Asia/Sakhalin",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Samara",
            "_type": "Europe/Samara",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Samarkand",
            "_type": "Asia/Samarkand",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Samoa",
            "_type": "Pacific/Pago_Pago",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Seychelles",
            "_type": "Indian/Mahe",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Shevchenko",
            "_type": "Asia/Aqtau",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Singapore",
            "_type": "Asia/Singapore",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Solomon",
            "_type": "Pacific/Guadalcanal",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "South_Georgia",
            "_type": "Atlantic/South_Georgia",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Suriname",
            "_type": "America/Paramaribo",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Sverdlovsk",
            "_type": "Asia/Yekaterinburg",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Syowa",
            "_type": "Antarctica/Syowa",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Tahiti",
            "_type": "Pacific/Tahiti",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Taipei",
            "_type": "Asia/Taipei",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Tajikistan",
            "_type": "Asia/Dushanbe",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Tashkent",
            "_type": "Asia/Tashkent",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Tbilisi",
            "_type": "Asia/Tbilisi",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Tokelau",
            "_type": "Pacific/Fakaofo",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Tonga",
            "_type": "Pacific/Tongatapu",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Truk",
            "_type": "Pacific/Truk",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Turkey",
            "_type": "Europe/Istanbul",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Turkmenistan",
            "_type": "Asia/Ashgabat",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Tuvalu",
            "_type": "Pacific/Funafuti",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Uralsk",
            "_type": "Asia/Oral",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Uruguay",
            "_type": "America/Montevideo",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Urumqi",
            "_type": "Asia/Urumqi",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Uzbekistan",
            "_type": "Asia/Tashkent",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Vanuatu",
            "_type": "Pacific/Efate",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Venezuela",
            "_type": "America/Caracas",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Vladivostok",
            "_type": "Asia/Vladivostok",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Volgograd",
            "_type": "Europe/Volgograd",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Vostok",
            "_type": "Antarctica/Vostok",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Wake",
            "_type": "Pacific/Wake",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Wallis",
            "_type": "Pacific/Wallis",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Yakutsk",
            "_type": "Asia/Yakutsk",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Yekaterinburg",
            "_type": "Asia/Yekaterinburg",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Yerevan",
            "_type": "Asia/Yerevan",
            "_territory": "001"
          }
        },
        {
          "mapZone": {
            "_other": "Yukon",
            "_type": "America/Whitehorse",
            "_territory": "001"
          }
        }
      ],
      "metazoneIds": {
        "acre": {
          "_longId": "Acre",
          "_since": "40"
        },
        "afce": {
          "_longId": "Africa_Central",
          "_since": "40"
        },
        "afea": {
          "_longId": "Africa_Eastern",
          "_since": "40"
        },
        "afgh": {
          "_longId": "Afghanistan",
          "_since": "40"
        },
        "afso": {
          "_longId": "Africa_Southern",
          "_since": "40"
        },
        "afwe": {
          "_longId": "Africa_Western",
          "_since": "40"
        },
        "alam": {
          "_longId": "Almaty",
          "_since": "40"
        },
        "alas": {
          "_longId": "Alaska",
          "_since": "40"
        },
        "amaz": {
          "_longId": "Amazon",
          "_since": "40"
        },
        "amce": {
          "_longId": "America_Central",
          "_since": "40"
        },
        "amea": {
          "_longId": "America_Eastern",
          "_since": "40"
        },
        "ammo": {
          "_longId": "America_Mountain",
          "_since": "40"
        },
        "ampa": {
          "_longId": "America_Pacific",
          "_since": "40"
        },
        "anad": {
          "_longId": "Anadyr",
          "_since": "40"
        },
        "apia": {
          "_longId": "Apia",
          "_since": "40"
        },
        "aqta": {
          "_longId": "Aqtau",
          "_since": "40"
        },
        "aqto": {
          "_longId": "Aqtobe",
          "_since": "40"
        },
        "arab": {
          "_longId": "Arabian",
          "_since": "40"
        },
        "arge": {
          "_longId": "Argentina",
          "_since": "40"
        },
        "arme": {
          "_longId": "Armenia",
          "_since": "40"
        },
        "arwe": {
          "_longId": "Argentina_Western",
          "_since": "40"
        },
        "atla": {
          "_longId": "Atlantic",
          "_since": "40"
        },
        "auce": {
          "_longId": "Australia_Central",
          "_since": "40"
        },
        "aucw": {
          "_longId": "Australia_CentralWestern",
          "_since": "40"
        },
        "auea": {
          "_longId": "Australia_Eastern",
          "_since": "40"
        },
        "auwe": {
          "_longId": "Australia_Western",
          "_since": "40"
        },
        "azer": {
          "_longId": "Azerbaijan",
          "_since": "40"
        },
        "azor": {
          "_longId": "Azores",
          "_since": "40"
        },
        "bang": {
          "_longId": "Bangladesh",
          "_since": "40"
        },
        "bhut": {
          "_longId": "Bhutan",
          "_since": "40"
        },
        "boli": {
          "_longId": "Bolivia",
          "_since": "40"
        },
        "bras": {
          "_longId": "Brasilia",
          "_since": "40"
        },
        "brun": {
          "_longId": "Brunei",
          "_since": "40"
        },
        "case": {
          "_longId": "Casey",
          "_since": "40"
        },
        "cave": {
          "_longId": "Cape_Verde",
          "_since": "40"
        },
        "cham": {
          "_longId": "Chamorro",
          "_since": "40"
        },
        "chat": {
          "_longId": "Chatham",
          "_since": "40"
        },
        "chil": {
          "_longId": "Chile",
          "_since": "40"
        },
        "chin": {
          "_longId": "China",
          "_since": "40"
        },
        "chri": {
          "_longId": "Christmas",
          "_since": "40"
        },
        "coco": {
          "_longId": "Cocos",
          "_since": "40"
        },
        "colo": {
          "_longId": "Colombia",
          "_since": "40"
        },
        "cook": {
          "_longId": "Cook",
          "_since": "40"
        },
        "cuba": {
          "_longId": "Cuba",
          "_since": "40"
        },
        "davi": {
          "_longId": "Davis",
          "_since": "40"
        },
        "dumo": {
          "_longId": "DumontDUrville",
          "_since": "40"
        },
        "east": {
          "_longId": "Easter",
          "_since": "40"
        },
        "eati": {
          "_longId": "East_Timor",
          "_since": "40"
        },
        "ecua": {
          "_longId": "Ecuador",
          "_since": "40"
        },
        "euce": {
          "_longId": "Europe_Central",
          "_since": "40"
        },
        "euea": {
          "_longId": "Europe_Eastern",
          "_since": "40"
        },
        "eufe": {
          "_longId": "Europe_Further_Eastern",
          "_since": "40"
        },
        "euwe": {
          "_longId": "Europe_Western",
          "_since": "40"
        },
        "falk": {
          "_longId": "Falkland",
          "_since": "40"
        },
        "fiji": {
          "_longId": "Fiji",
          "_since": "40"
        },
        "frgu": {
          "_longId": "French_Guiana",
          "_since": "40"
        },
        "frso": {
          "_longId": "French_Southern",
          "_since": "40"
        },
        "gala": {
          "_longId": "Galapagos",
          "_since": "40"
        },
        "gamb": {
          "_longId": "Gambier",
          "_since": "40"
        },
        "geor": {
          "_longId": "Georgia",
          "_since": "40"
        },
        "giis": {
          "_longId": "Gilbert_Islands",
          "_since": "40"
        },
        "grea": {
          "_longId": "Greenland_Eastern",
          "_since": "40"
        },
        "gree": {
          "_longId": "Greenland",
          "_since": "40"
        },
        "grwe": {
          "_longId": "Greenland_Western",
          "_since": "40"
        },
        "guam": {
          "_longId": "Guam",
          "_since": "40"
        },
        "gulf": {
          "_longId": "Gulf",
          "_since": "40"
        },
        "guya": {
          "_longId": "Guyana",
          "_since": "40"
        },
        "haal": {
          "_longId": "Hawaii_Aleutian",
          "_since": "40"
        },
        "hoko": {
          "_longId": "Hong_Kong",
          "_since": "40"
        },
        "hovd": {
          "_longId": "Hovd",
          "_since": "40"
        },
        "hwai": {
          "_longId": "Hawaii",
          "_since": "40"
        },
        "ince": {
          "_longId": "Indonesia_Central",
          "_since": "40"
        },
        "indi": {
          "_longId": "India",
          "_since": "40"
        },
        "indo": {
          "_longId": "Indochina",
          "_since": "40"
        },
        "inea": {
          "_longId": "Indonesia_Eastern",
          "_since": "40"
        },
        "inoc": {
          "_longId": "Indian_Ocean",
          "_since": "40"
        },
        "inwe": {
          "_longId": "Indonesia_Western",
          "_since": "40"
        },
        "iran": {
          "_longId": "Iran",
          "_since": "40"
        },
        "irku": {
          "_longId": "Irkutsk",
          "_since": "40"
        },
        "isra": {
          "_longId": "Israel",
          "_since": "40"
        },
        "japa": {
          "_longId": "Japan",
          "_since": "40"
        },
        "kaea": {
          "_longId": "Kazakhstan_Eastern",
          "_since": "40"
        },
        "kamc": {
          "_longId": "Kamchatka",
          "_since": "40"
        },
        "kawe": {
          "_longId": "Kazakhstan_Western",
          "_since": "40"
        },
        "kaza": {
          "_longId": "Kazakhstan",
          "_since": "40"
        },
        "kore": {
          "_longId": "Korea",
          "_since": "40"
        },
        "kosr": {
          "_longId": "Kosrae",
          "_since": "40"
        },
        "kras": {
          "_longId": "Krasnoyarsk",
          "_since": "40"
        },
        "kyrg": {
          "_longId": "Kyrgystan",
          "_since": "40"
        },
        "lank": {
          "_longId": "Lanka",
          "_since": "40"
        },
        "liis": {
          "_longId": "Line_Islands",
          "_since": "40"
        },
        "loho": {
          "_longId": "Lord_Howe",
          "_since": "40"
        },
        "maca": {
          "_longId": "Macau",
          "_since": "40"
        },
        "maga": {
          "_longId": "Magadan",
          "_since": "40"
        },
        "mais": {
          "_longId": "Marshall_Islands",
          "_since": "40"
        },
        "mala": {
          "_longId": "Malaysia",
          "_since": "40"
        },
        "mald": {
          "_longId": "Maldives",
          "_since": "40"
        },
        "marq": {
          "_longId": "Marquesas",
          "_since": "40"
        },
        "maur": {
          "_longId": "Mauritius",
          "_since": "40"
        },
        "maws": {
          "_longId": "Mawson",
          "_since": "40"
        },
        "mepa": {
          "_longId": "Mexico_Pacific",
          "_since": "40"
        },
        "mgmt": {
          "_longId": "GMT",
          "_since": "40"
        },
        "mong": {
          "_longId": "Mongolia",
          "_since": "40"
        },
        "mosc": {
          "_longId": "Moscow",
          "_since": "40"
        },
        "myan": {
          "_longId": "Myanmar",
          "_since": "40"
        },
        "naur": {
          "_longId": "Nauru",
          "_since": "40"
        },
        "neca": {
          "_longId": "New_Caledonia",
          "_since": "40"
        },
        "nepa": {
          "_longId": "Nepal",
          "_since": "40"
        },
        "newf": {
          "_longId": "Newfoundland",
          "_since": "40"
        },
        "neze": {
          "_longId": "New_Zealand",
          "_since": "40"
        },
        "niue": {
          "_longId": "Niue",
          "_since": "40"
        },
        "noma": {
          "_longId": "North_Mariana",
          "_since": "40"
        },
        "norf": {
          "_longId": "Norfolk",
          "_since": "40"
        },
        "noro": {
          "_longId": "Noronha",
          "_since": "40"
        },
        "novo": {
          "_longId": "Novosibirsk",
          "_since": "40"
        },
        "omsk": {
          "_longId": "Omsk",
          "_since": "40"
        },
        "paki": {
          "_longId": "Pakistan",
          "_since": "40"
        },
        "pala": {
          "_longId": "Palau",
          "_since": "40"
        },
        "pang": {
          "_longId": "Papua_New_Guinea",
          "_since": "40"
        },
        "para": {
          "_longId": "Paraguay",
          "_since": "40"
        },
        "peru": {
          "_longId": "Peru",
          "_since": "40"
        },
        "phil": {
          "_longId": "Philippines",
          "_since": "40"
        },
        "phis": {
          "_longId": "Phoenix_Islands",
          "_since": "40"
        },
        "pimi": {
          "_longId": "Pierre_Miquelon",
          "_since": "40"
        },
        "pitc": {
          "_longId": "Pitcairn",
          "_since": "40"
        },
        "pona": {
          "_longId": "Ponape",
          "_since": "40"
        },
        "pyon": {
          "_longId": "Pyongyang",
          "_since": "40"
        },
        "qyzy": {
          "_longId": "Qyzylorda",
          "_since": "40"
        },
        "reun": {
          "_longId": "Reunion",
          "_since": "40"
        },
        "roth": {
          "_longId": "Rothera",
          "_since": "40"
        },
        "sakh": {
          "_longId": "Sakhalin",
          "_since": "40"
        },
        "sama": {
          "_longId": "Samara",
          "_since": "40"
        },
        "samo": {
          "_longId": "Samoa",
          "_since": "40"
        },
        "seyc": {
          "_longId": "Seychelles",
          "_since": "40"
        },
        "sing": {
          "_longId": "Singapore",
          "_since": "40"
        },
        "soge": {
          "_longId": "South_Georgia",
          "_since": "40"
        },
        "solo": {
          "_longId": "Solomon",
          "_since": "40"
        },
        "suri": {
          "_longId": "Suriname",
          "_since": "40"
        },
        "syow": {
          "_longId": "Syowa",
          "_since": "40"
        },
        "tahi": {
          "_longId": "Tahiti",
          "_since": "40"
        },
        "taip": {
          "_longId": "Taipei",
          "_since": "40"
        },
        "taji": {
          "_longId": "Tajikistan",
          "_since": "40"
        },
        "toke": {
          "_longId": "Tokelau",
          "_since": "40"
        },
        "tong": {
          "_longId": "Tonga",
          "_since": "40"
        },
        "truk": {
          "_longId": "Truk",
          "_since": "40"
        },
        "turk": {
          "_longId": "Turkmenistan",
          "_since": "40"
        },
        "tuva": {
          "_longId": "Tuvalu",
          "_since": "40"
        },
        "urug": {
          "_longId": "Uruguay",
          "_since": "40"
        },
        "uzbe": {
          "_longId": "Uzbekistan",
          "_since": "40"
        },
        "vanu": {
          "_longId": "Vanuatu",
          "_since": "40"
        },
        "vene": {
          "_longId": "Venezuela",
          "_since": "40"
        },
        "vlad": {
          "_longId": "Vladivostok",
          "_since": "40"
        },
        "volg": {
          "_longId": "Volgograd",
          "_since": "40"
        },
        "vost": {
          "_longId": "Vostok",
          "_since": "40"
        },
        "wake": {
          "_longId": "Wake",
          "_since": "40"
        },
        "wall": {
          "_longId": "Wallis",
          "_since": "40"
        },
        "yaku": {
          "_longId": "Yakutsk",
          "_since": "40"
        },
        "yeka": {
          "_longId": "Yekaterinburg",
          "_since": "40"
        },
        "yuko": {
          "_longId": "Yukon",
          "_since": "40"
        }
      }
    }
  }
}
